<template>
  <div id="nav">
    <div class="navBar">
      <div class="nav-right">
        <a href="https://os-system.com" target="_blank" rel="noreferrer">
          <img
            src="../assets/img/logo.svg"
            alt="ossystem logo"
          />
        </a>
      </div>
      <div class="nav-left">
        <ul class="nav-menu">
          <li
            class="nav-menu-item"
            v-scroll-to="{
              el: '#services',
              duration: 500,
              easing: 'linear',
              offset: this.handleServiceOffSet(),
            }"
          >{{ $t('nav-menu.services') }}</li>
          <li
            class="nav-menu-item"
            v-scroll-to="{
              el: '#portfolio',
              duration: 500,
              easing: 'linear',
              offset: -150,
            }"
          >Projects</li>
          <li
            class="nav-menu-item"
            v-scroll-to="{
              el: '#slider',
              duration: 500,
              easing: 'linear',
              offset: this.handleReviewsOffSet(),
            }"
          >{{ $t('nav-menu.reviews') }}</li>
          <li>
            <button
              class="nav-btn nav-btn-contact"
              v-scroll-to="{
              el: '#footer-form',
              duration: 500,
              easing: 'linear',
              offset: this.handleContactOffSet(),
            }"
            >{{ $t('nav-menu.contact') }}</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navBar",
  props: {
    width: { type: Number, default: null },
  },
  data: () => ({
    lang: "se",
    url: window.location.pathname === '/thank-you',
  }),
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.lang = locale;
    },
    handleServiceOffSet() {
      switch (this.width) {
        case 768:
          return -140;
        default:
          return 0;
      }
    },
    handleReviewsOffSet() {
      switch (this.width) {
        case 768:
          return -100;
        default:
          return 0;
      }
    },
    handleContactOffSet() {
      if (this.width === 768) return -60;
      if (this.width < 480 && this.width > 320) return -100;
      if (this.width === 320) return 50;
      return 0;
    },
  },
};
</script>

<style scoped lang="scss">
@mixin font {
  font-family: "Roboto", sans-serif;
}
.activeLang {
  color: #1899e1 !important;
}
.navBar {
  width: 1040px;
  height: 100px;
  transform: translateX(-50%);
  left: 50%;
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 1130px) {
    width: 90%;
    height: 80px;
    max-width: initial;
  }

  @media screen and (max-width: 1012px) {
    max-width: 668px;
    left: 51%;
  }

  @media screen and (max-width: 767px) {
    // max-width: 533px;
    max-width: initial;
    left: 50%;
    height: 65px;
  }
}

.active-nav {
  top: 0px !important;
  height: 100px;
  background: #FFFDF9;
  z-index: 10;
  width: 100% !important;
  box-shadow: 0px 4px 15px #f7eddb;
  @media screen and (max-width: 1130px) {
    height: 80px;
  }
  @media screen and (max-width: 767px) {
    height: 65px;
  }
  @media screen and (max-width: 480px) {
    width: 55px;
  }
}

.nav-left {
  width: 40%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media screen and (max-width: 1130px) {
    width: 402px;
  }
  @media screen and (max-width: 767px) {
    width: initial;
    height: 30px;
  }
}

.nav-right {
  img {
    cursor: pointer;
  }
  @media screen and (max-width: 1130px) {
    img {
      width: 120px;
      height: 35px;

      @media screen and (max-width: 767px) {
        width: 103px;
        height: 30px;
      }

      @media screen and (max-width: 430px) {
        width: 85px;
        height: 25px;
      }
    }
  }
}

.nav-menu {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 1012px) {
    width: 88%;
  }
  @media screen and (max-width: 767px) {
    width: 100%;
  }
}

.divider {
  width: 1px;
  height: 13px;
  background-color: #000000;
}

.nav-left-lang-btn {
  width: 60px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  a {
    outline: none;
    background: none;
    color: #000000;
    text-decoration: none;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 27px;
    text-transform: uppercase;
    font-family: Roboto;
    font-size: 18px;
    line-height: 27px;
    color: #000000;
  }
}

.nav-menu-item,
.nav-btn {
  text-transform: capitalize;
  cursor: pointer;
}

.nav-menu-item,
.nav-btn,
.nav-left-lang-btn a {
  @include font;
}

.nav-btn {
  width: 122px;
  height: 45px;

  background: #1899e1;
  border-radius: 40px;
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  line-height: 27px;
  color: #ffffff;
  @media screen and (min-width: 769px) {
    &:hover {
      background: #26b1ff;
      box-shadow: 0px 0px 15px #26b1ff;
    }

    &:active {
      background: #1187ca;
      box-shadow: none !important;
    }

    // &:focus {
    //   box-shadow: none !important;
    // }
  }
  @media screen and (max-width: 1130px) {
    width: 122px;
    height: 40px;
    font-size: 16px;
    line-height: 27px;
  }
  @media screen and (max-width: 1012px) {
    font-size: 14px;
    line-height: 27px;
  }

  @media screen and (max-width: 430px) {
    width: 92px;
    height: 35px;
  }
}

.nav-menu-item {
  font-size: 18px;
  line-height: 27px;
  // width: 67px;
  &:hover {
    font-weight: bold;
    color: #1899E1;
  }
  @media screen and (max-width: 1130px) {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 27px;
    color: #000000;
  }
  @media screen and (max-width: 1012px) {
    font-size: 14px;
    line-height: 27px;
    width: initial;
  }

  @media screen and (max-width: 767px) {
    display: none;
  }
}
</style>
